export const visit = (vm, at) => {
vm(require("commerce-contract-lib/lang/en.lyaml"));
at({ "en": { "cardDealSharedView": { "profileSidebarModule": { "dealSharedViewModule": { "headerLabel": "Shared Deal" } } } } });
};